import React from "react";

const Menu = ({ menus, onClickMenuItem }) => {
  return (
    <div>
      {/* Header */}
      <div className="head-general bg-gray with-back">
        <a
          href="javascript: void(0)"
          onClick={() => onClickMenuItem(null)}
          className="back"
        >
          <img src="/png/chevron-left.png" />
        </a>
        <h4>Ranking</h4>
        <a href="javascript: void(0)" className="close" />
      </div>
      {/* Header */}
      <div className="short-by">
        <div className="list">
          <ul>
            {(menus &&
              menus.length &&
              menus.map(menuItem => (
                <li
                  onClick={() => onClickMenuItem(menuItem.id)}
                  key={menuItem.id}
                >
                  {menuItem.name}
                </li>
              ))) || <li>No found menu item</li>}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Menu;
